// react components
import React from 'react'

// props
type ErrorHelper825Props = {
    error: string | undefined
}

// main
export const ErrorHelper825: React.FC<ErrorHelper825Props> = React.memo(({
    error,
}) => {

    if (error) {
        return (
            <span className='error-helper-825'>{error}</span>
        )
    }
    return null
})
